export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_FORMAT_INPUT = 'DD-MM-YYYY';
export const DATE_FORMAT_PLACEHOLDER = 'DD-MM-AAAA';

export const DATE_TIME_FORMAT = 'DD-MM-YYYY HH:mm';

export const TIME_FORMAT = 'HH:mm';
